module.exports = __webpack_public_path__ + "media/images/picto_logement_entier_black-49d07be205ace48a18ae57001fd94a9f.svg";